import('./filter_view.css')
export default function(){
    let elements = {}
    let filter_options
    
    this.generate = () =>{
        elements.container = createElement('div', 'filter-view-container')
        elements.items = createElement('div', 'filter-view-items-wrapper')
        // elements.button = createElement('div', 'filter-view-button')
        // $(elements.button).html('Todos os filtros')
        $(elements.container).append(elements.items)
        $('section').append(elements.container)
    }

    this.setFilter = options =>{
        filter_options = options
        this.update()
    }

    this.update = () =>{
        this.clearItems()
        $.each(filter_options, (field, values) =>{
            this.generateBread(field,values)
        })
    }

    this.clearItems = _ =>{
        $(elements.items).html("")
        elements.filterItems = []
    }

    this.generateBread = (field,values) =>{
        if(!elements.filterItems){
            elements.filterItems = []
        }
        
        let filterViewItem = new FilterViewItem({field:field, values:values})
        elements.filterItems.push(filterViewItem)
        $(filterViewItem).on('clear-click', _=>{
            $(this).trigger('clear-filter-option', {option:field})
        })

        $(elements.items).append(filterViewItem.getElement())
    }
    
    this.hide = boolean =>{
        $(elements.container).toggleClass('hide', boolean)
    }

    function FilterViewItem(opts){
        let elements = {}
        let field = opts.field
        let values = opts.values

        this.getElement = () =>{
            return elements.container
        }

        this.destroy = _ =>{
            this.getElement().remove()
        }

        init.call(this)

        function init(){
            elements.container = createElement('div', 'filter-view-item')
            elements.text = createElement('div', 'filter-view-item-text')
            elements.icon = createElement('div', 'filter-view-item-icon')

            $(elements.text).html(sanitizeText(field))

            if(values.length == 1){
                // $(elements.text).append(`: <strong>${values[0]}</strong>`)
            }

            elements.icon.innerHTML = ''

            $(elements.container).append(elements.text, elements.icon)

            $(elements.icon).on('click', _=>{
                this.destroy()
                $(this).trigger('clear-click')
            })
        }
    }

    function createElement(type,classList){
        let el = document.createElement(type)
        if(classList){
            $(el).addClass(classList)
        }
        return el
    }

    function sanitizeText(text){
        let words = {
            transmission_status_id: 'Status da Transmissão',
            ugrhi_id: 'Ugrhi',
            city_id: 'Cidade',
            station_owner_id: 'Proprietário'
        }
        return words[text] || `Definir sanataze para ${text}`
    }
}